/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Form, InputPlaceholder, Styles } from '@contently/toolkit';
import Select from 'react-select';
import { Field } from 'react-final-form';
import ReactPlaceholder from 'react-placeholder';
import InputHeightWrapper from './InputHeightWrapper';

const { Label, ErrorWrapper } = Form;

const borderColorPicker = (val, touched, focused, error) => {
  let color = Styles.colors.grey.altLight;

  if (val || focused) {
    color = Styles.colors.blue.primaryDark;
  }

  if (error && touched) {
    color = Styles.colors.red.primary;
  }

  return color;
};

const customSelectStyles = (val, touched, error) => ({

  control: (base, state) => ({
    ...base,
    boxShadow: 'none',
    background: '#F6F6F6',
    border: `transparent`,
    borderRadius: '3px 3px 0 0',
    borderBottom: `2px solid ${borderColorPicker(val, touched, state.isFocused, error)}`,
    textTransform: 'none',
    fontWeight: '400',
    fontSize: '12px',
    '&:hover': {
      borderColor: Styles.colors.blue.primaryDark
    }
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: `${state.isFocused ? Styles.colors.blue.primaryDark : Styles.colors.grey.altLight}`
  }),
  menuList: (base) => ({
    ...base,
    textTransform: 'none',
    fontWeight: '400',
    fontSize: '12px',
    color: Styles.colors.black
  })
});

const StyledLabel = styled(Label)`
  color: #0094ab;
  font-size: 12px;
  div[class*='Error'] {
    font-size: 10px;
    font-weight: 300;
  }
`

const SelectField = props => {
  const { name, label, options, fetching, validate, withLabel } = props;

  // eslint-disable-next-line react/prop-types
  const Input = ({ input, meta }) => {
    const selectInput = (
      <ErrorWrapper touched={meta.touched} error={meta.error}>
        <Select {...input} options={options} styles={customSelectStyles(input.value, meta.touched, meta.error)} />
      </ErrorWrapper>
    );

    const labelComponent = (
      <StyledLabel>
        {label || name}
        <InputHeightWrapper>{selectInput}</InputHeightWrapper>
      </StyledLabel>
    );
    let select = selectInput;

    if (withLabel) {
      select = labelComponent;
    }
    return (
      <ReactPlaceholder
        showLoadingAnimation
        customPlaceholder={<InputPlaceholder wrapperClass="row" withLabel={withLabel} />}
        ready={!fetching}
      >
        {select}
      </ReactPlaceholder>
    );
  };

  return (
    <Field
      name={name}
      parse={val => val && val.value}
      format={val => options.find(o => o.value === val)}
      render={Input}
      validate={validate}
    />
  );
};

SelectField.defaultProps = {
  withLabel: true,
  label: null,
  fetching: false
};

SelectField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string.isRequired, value: PropTypes.string.isRequired })
  ).isRequired,
  fetching: PropTypes.bool,
  withLabel: PropTypes.bool
};

export default SelectField;
